import type { Eq } from 'fp-ts/lib/Eq';
import deepEqual from 'react-fast-compare';
import { shallowEqual } from 'react-redux';

export const is =
  <T>(x: T) =>
  (y: T): boolean =>
    x === y;

export const isNot =
  <T>(x: T) =>
  (y: T): boolean =>
    x !== y;

export const eqDeepStrict: Eq<unknown> = {
  equals: (x: unknown, y: unknown) => deepEqual(x, y),
};
export const eqShallow: Eq<unknown> = { equals: shallowEqual };
